import { BaseSanitizer } from './BaseSanitizer';
export class CryptoWalletSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'CRYPTO_WALLET', 'cryptoWallets', enabled);
    }
    detectMatches(text) {
        const matches = [];
        const bitcoinMatches = this.detectBitcoinAddresses(text);
        const ethereumMatches = this.detectEthereumAddresses(text);
        const litecoinMatches = this.detectLitecoinAddresses(text);
        const cardanoMatches = this.detectCardanoAddresses(text);
        const solanaMatches = this.detectSolanaAddresses(text);
        matches.push(...bitcoinMatches, ...ethereumMatches, ...litecoinMatches, ...cardanoMatches, ...solanaMatches);
        return this.removeOverlappingMatches(matches);
    }
    detectBitcoinAddresses(text) {
        const matches = [];
        const patterns = [
            /\b[13][a-km-zA-HJ-NP-Z1-9]{25,34}\b/g, // Legacy (1) and P2SH (3) addresses
            /\bbc1[a-z0-9]{39,59}\b/g // Native SegWit (Bech32) addresses
        ];
        for (const pattern of patterns) {
            let match;
            while ((match = pattern.exec(text)) !== null) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
    detectEthereumAddresses(text) {
        const matches = [];
        const ethPattern = /\b0x[a-fA-F0-9]{40}\b/g;
        let match;
        while ((match = ethPattern.exec(text)) !== null) {
            if (this.looksLikeEthContext(text, match.index)) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
    detectLitecoinAddresses(text) {
        const matches = [];
        const ltcPattern = /\b[LM][a-km-zA-HJ-NP-Z1-9]{33}\b/g;
        let match;
        while ((match = ltcPattern.exec(text)) !== null) {
            matches.push({
                originalText: match[0],
                tag: '',
                startIndex: match.index,
                endIndex: match.index + match[0].length
            });
        }
        return matches;
    }
    detectCardanoAddresses(text) {
        const matches = [];
        const adaPattern = /\baddr1[a-z0-9]{57,103}\b/g;
        let match;
        while ((match = adaPattern.exec(text)) !== null) {
            matches.push({
                originalText: match[0],
                tag: '',
                startIndex: match.index,
                endIndex: match.index + match[0].length
            });
        }
        return matches;
    }
    detectSolanaAddresses(text) {
        const matches = [];
        const solPattern = /\b[1-9A-HJ-NP-Za-km-z]{32,44}\b/g;
        let match;
        while ((match = solPattern.exec(text)) !== null) {
            if (this.looksLikeSolContext(text, match.index)) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
    looksLikeEthContext(text, index) {
        const before = text.substring(Math.max(0, index - 20), index).toLowerCase();
        const after = text.substring(index, Math.min(text.length, index + 10)).toLowerCase();
        const keywords = ['eth', 'ethereum', 'wallet', 'address', 'send', 'transfer', 'crypto', 'token', 'contract'];
        return keywords.some(keyword => before.includes(keyword) || after.includes(keyword));
    }
    looksLikeSolContext(text, index) {
        const before = text.substring(Math.max(0, index - 20), index).toLowerCase();
        const after = text.substring(index, Math.min(text.length, index + 10)).toLowerCase();
        const keywords = ['sol', 'solana', 'wallet', 'address', 'send', 'transfer', 'crypto', 'nft', 'phantom'];
        return keywords.some(keyword => before.includes(keyword) || after.includes(keyword));
    }
}
